import { useEffect, useState } from 'react';
import Button from './ui/Button';

export default function BackToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    function onScroll() {
      setVisible(window.scrollY > 400);
    }
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  if (!visible) return null;

  return (
    <div className="fixed bottom-6 right-6 z-40 hidden sm:block">
      <Button
        type="button"
        variant="secondary"
        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
        className="shadow-lg focus:ring-offset-white"
      >
        Back to top
      </Button>
    </div>
  );
}
